import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import {
  MAX_50_CHARS,
  MAX_AMT_LIMIT_REACHED,
  MAX_QTY_LIMIT_REACHED,
} from "../../Constants/stringConstants";
import { isNullOrEmpty } from "../../Utils/stringUtils";
import { warn } from "../../Wrapper/toast/toast";
import DatePickerWrapper from "../_widgets/Datepicker/DatePicker";
import Input from "../_widgets/Input/Input";
import BasicModal from "../_widgets/Modal/BasicModal";

const AddStockModal = ({
  modalShow,
  setModalShow,
  handleClose,
  addInventoryData,
  addInventory,
  buttonLoading,
  setAddInventoryData,
}) => {
  return (
    <BasicModal
      show={modalShow}
      size="lg"
      setModalShow={setModalShow}
      handleClose={handleClose}
      heading={`${"Add"} Inventory Stock`}
      footer
      minH={"55vh"}
      button2Text="Save"
      button2Click={() => addInventory()}
      loading={buttonLoading}
    >
      <div className="patients_ui">
        <Row>
          <Col xl={12}>
            <div className="white_card text-start">
              <Row className="mb-3">
                <Col lg={4}>
                  <Input
                    isRequired={true}
                    placeholder="Enter Quantity"
                    type="number"
                    step="0.25"
                    min="0.25"
                    label="Quantity"
                    value={addInventoryData?.qty}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value > 99999) {
                        warn(MAX_QTY_LIMIT_REACHED);
                      } else {
                        let val = parseFloat(e.target.value);

                        if (isNaN(val)) {
                          setAddInventoryData({
                            ...addInventoryData,
                            qty: "",
                          });
                          return;
                        }

                        // Round to nearest 0.25
                        val = Math.round(val * 4) / 4;

                        // Ensure minimum value is 0.25
                        if (val < 0.25) val = 0.25;

                        setAddInventoryData({
                          ...addInventoryData,
                          qty: val,
                        });
                      }
                    }}
                  />
                </Col>

                <Col lg={4}>
                  <Input
                    // isRequired={true}
                    inputType="currency"
                    placeholder="Enter Total Amount"
                    label="Total Amount"
                    allowDecimals={true}
                    currencyPrefix={true}
                    value={addInventoryData?.amount}
                    onValueChange={(val) => {
                      if (val <= 99999 || isNullOrEmpty(val)) {
                        setAddInventoryData({
                          ...addInventoryData,
                          amount: val,
                        });
                      } else {
                        warn(MAX_AMT_LIMIT_REACHED);
                      }
                    }}
                  />
                </Col>

                <Col log={4}>
                  <div className="date_range_picker">
                    <DatePickerWrapper
                      isRequired={true}
                      label="Date"
                      selected={addInventoryData?.date}
                      value={addInventoryData?.date}
                      onChange={(date) =>
                        setAddInventoryData({
                          ...addInventoryData,
                          date: date,
                        })
                      }
                    />
                  </div>
                </Col>
                <Col lg={12}>
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Enter Remarks"
                    rows={4}
                    value={addInventoryData.remarks}
                    onChange={(e) => {
                      if (e.target.value.length <= 50) {
                        setAddInventoryData({
                          ...addInventoryData,
                          remarks: e.target.value,
                        });
                      } else {
                        warn(MAX_50_CHARS);
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </BasicModal>
  );
};

export default AddStockModal;
